module.exports = __webpack_public_path__ + "img/thank-you-bg.4e1cd8cc.jpg";